<div>
  <h3>Workflows</h3>

  <div class="row">
    <div class="col" *ngIf="canCreateWorkflow">
      <div class="btn-group float-right" ngbDropdown placement="bottom-right">
        <button 
          type="button" 
          class="btn btn-raised btn-success float-right" 
          *ngIf="!canCreateFromTemplate"
          (click)="createWorkflow()"
        >
          New Workflow
        </button>

        <wm-modal-confirm 
          #newWorkflow buttonText="New Workflow" 
          [showButton]="true" 
          [showButtonText]="true"
          buttonClass="btn btn-raised btn-success" 
          *ngIf="canCreateFromTemplate"
        >
          <h2>New Workflow</h2>
          <div class="row">
            <div class="col-12 col-lg-6">
              <div class="card">
                <div class="card-body">
                  <h4>Start from blank</h4>
                  <p>This will create a new blank workflow with just a start activity.</p>
                  <button 
                    type="button" 
                    class="btn btn-raised btn-primary btn-block"
                    (click)="newWorkflow.accept();createWorkflow()"
                  >
                    Create Blank
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 mt-3 mt-lg-0">
              <div class="card">
                <div class="card-body">
                  <h4>Start from a template</h4>
                  <p>This will allow yout to select a workflow from our template library to use as a starting point.
                  </p>
                  <button 
                  class="btn btn-primary btn-raised btn-block" 
                  (click)="newWorkflow.accept()"
                  [routerLink]="[
                    '/admin/jurisdiction', 
                    _context?.client?.id, 
                    'workflows', 
                    'template-library'
                  ]"
                  >
                    Create From Template
                  </button>
                </div>
              </div>
            </div>
          </div>
        </wm-modal-confirm>
      </div>
    </div>
  </div>

  <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink>Workflows</a>
      <ng-template ngbNavContent>
        <wm-workflow-list 
          [clientId]="_context?.client?.id" 
          [workflows]="workflows" 
          [showEdit]="true"
          [loadGlobal]="loadGlobal" 
          (onRestore)="restoreWorkflow($event)" 
          (onDisable)="disableWorkflow($event)"
          (onEnable)="enableWorkflow($event)" 
          (onPublish)="publishWorkflow($event)"
          (onArchive)="archiveWorkflow($event)" 
          (onCopy)="copyWorkflow($event)"
          (toggleVisible)="toggleVisibleToPublic($event)"
        ></wm-workflow-list>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink>Archive</a>
      <ng-template ngbNavContent>
        <wm-workflow-list 
          [clientId]="_context?.client?.id" 
          [workflows]="archivedWorkflows" 
          [showEdit]="true"
          (onRestore)="restoreWorkflow($event)" 
          (onDisable)="disableWorkflow($event)"
          (onEnable)="enableWorkflow($event)" 
          (onPublish)="publishWorkflow($event)"
          (onArchive)="archiveWorkflow($event)" 
          (onCopy)="copyWorkflow($event)"
        ></wm-workflow-list>
      </ng-template>
    </li>
    <li 
      ngbNavItem
      *ngIf="canCreateFromTemplate"
    >
      <a ngbNavLink>Pending</a>
      <ng-template ngbNavContent>
        <wm-pending-workflow-list></wm-pending-workflow-list>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
